import { AgentHistoryTable } from "@circuitry-ai/doc-agent";

export function HistoryPage() {
    return (
        <div className='flex flex-col h-full min-h-0'>
            <div className="flex-1 min-h-0 overflow-hidden">
                <AgentHistoryTable />
            </div>
        </div>
    );
}

export default HistoryPage;
